import { SlideType } from '../firestore/Slide/types'

/**
 * True unless the slide type is one of the quiz types that never use a
 * suggested timer (BL-4567: Solo Quiz, Group Quiz). These are completed
 * individually, so a countdown adds no value. Poll keeps its timer. The editor
 * hides the timer toggle for the quiz types and the runtime treats any
 * suggestedTimer question left on such a slide as absent.
 *
 * An undefined type (e.g. a form still initialising) returns false — the safe
 * default is "does not support a timer" until the type is known.
 */
export function slideTypeSupportsSuggestedTimer(
  type: SlideType | undefined
): boolean {
  if (type === undefined) return false
  return type !== SlideType.soloQuiz && type !== SlideType.interactiveQuiz
}
